<template>
  <div>
    <TWLoadingSpinner v-if="loading" />
    <div>
      <h3>{{ $t('companySettings.developer.defaultSharingSettings.title') }}</h3>
      <SharingView
        v-if="hasLoaded"
        @itemAdded="itemAdded"
        @itemRemoved="itemRemoved"
        :permittedActorsListTitle="$t('companySharing.permittedActorsListTitle')"
        :typeVisibility="typeVisibility"
        v-model="sharingSettings"
        @permissionChanged="handlePermissionChanged"
      />
      <button
        type="button"
        class="tw-button tw-button-cta"
        data-test="save-button"
        data-ec="company_sharing"
        data-et="btn_save"
        @click="save">
        <span>{{ $t('functional.save') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SharingView from '@/components/Sharing.vue';
import TWLoadingSpinner from '@/components/tailwind/LoadingSpinner.vue';
import { logAmplitudeEvent } from '@/utils/analytics';

export default {
  components: {
    SharingView,
    TWLoadingSpinner,
  },
  created() {
    this.loading = true;
    this.$store.dispatch('company/GET_DEFAULT_SHARING_SETTINGS').finally(() => {
      this.sharingSettings = this.defaultSharingSettings;
      this.hasLoaded = true;
      this.loading = false;
    });
  },
  data() {
    return {
      loading: false,
      sharingSettings: {},
      hasLoaded: false,
      typeVisibility: {
        private: false,
      },
    };
  },
  methods: {
    handlePermissionChanged(value) {
      logAmplitudeEvent('company_sharing--permission_changed', { type: value.slug });
    },
    itemAdded(item) {
      logAmplitudeEvent('company_sharing--added_actor_to_company_sharing', { type: item.type });
    },
    itemRemoved(item) {
      logAmplitudeEvent('company_sharing--removed_actor_from_company_sharing', { type: item.type });
    },
    async save() {
      this.loading = true;
      await this.$store.dispatch('company/UPDATE_DEFAULT_SHARING_SETTINGS', {
          data: this.sharingSettings,
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    ...mapGetters({
      defaultSharingSettings: 'company/defaultSharingSettings',
    }),
  },
};
</script>
